import React, { useContext, useEffect, useState } from 'react';

import {
  Card,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  Typography
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import HierarchicalBreadcrumbs from '../../components/other/HierarchicalBreadcrumbs';
import Questionnaire from '../../components/other/questionnaire/Questionnaire';
import { fetchQuestionnaires } from '../../store/slices/questionnaireSlice';

export default function PersonalityQuestionnaireView() {
  const dispatch = useDispatch();
  const questionnaireStatus = useSelector(
    (state) => state.questionnaires.status
  );

  useEffect(() => {
    if (questionnaireStatus === 'idle') {
      dispatch(fetchQuestionnaires());
    }
  }, [questionnaireStatus, dispatch]);

  return (
    <div className="PersonalityQuestionnaire mt-7">
      <div className="flex justify-between ml-10 items-center">
        <HierarchicalBreadcrumbs
          outcomes={true}
          questionnaire={true}
          personality={true}
        />
      </div>
      <div className="flex justify-center">
        <Card className="m-2 my-4 p-2 w-10/12 overflow-y-auto overflow-x-hidden relative shadow-md sm:rounded-lg">
          <Typography
            sx={{ fontWeight: 700, fontSize: '1.2rem' }}
            className="text-center">
            Personality Profile Questionnaire
          </Typography>
          <div className="flex flex-col items-center justify-center">
            <div className="w-full sm:11/12 md:5/6 lg:w-4/5 xl:w-2/3">
              <Typography
                sx={{ fontWeight: 700, fontSize: '1rem' }}
                className="">
                Instructions
              </Typography>
              <div className="break-words text-xs font-medium m-1 my-2 max-h-48 overflow-y-auto">
                <List
                  sx={{
                    listStyleType: 'disc',
                    '& .MuiListItem-root': {
                      display: 'list-item'
                    }
                  }}>
                  <ListItem>
                    <Typography sx={{ fontSize: '0.9rem' }}>
                      Describe yourself as you generally are now, not as you
                      wish to be in the future.
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography sx={{ fontSize: '0.9rem' }}>
                      Describe yourself as you honestly see yourself, in
                      relation to other people you know of the same sex as you
                      are, and roughly your same age.
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography sx={{ fontSize: '0.9rem' }}>
                      So that you can describe yourself in an honest manner,
                      your responses will be kept in absolute confidence.
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography sx={{ fontSize: '0.9rem' }}>
                      Indicate for each statement whether it is: 1. Very
                      Inaccurate, 2. Moderately Inaccurate, 3. Neither Accurate
                      Nor Inaccurate, 4. Moderately Accurate, or 5. Very
                      Accurate as a description of you.
                    </Typography>
                  </ListItem>
                </List>
              </div>
            </div>
            <div className="w-full sm:11/12 md:5/6 lg:w-4/5 xl:w-2/3">
              <Questionnaire questionnaireId="2" />
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
